<!-- InserirDadosBasico.svelte -->
<svelte:options accessors />

<script>
  import { Switch } from "@svelteuidev/core";
  import Conexoes from "../../Classes/Conexoes.js";
  import Constantes from "../../Classes/Constantes.js";
  import { Tipo } from "../../Classes/ItemInserir.js";
  import CaixaDeDialogo from "../../componentes_basicos/CaixaDeDialogo.svelte";
  import DropDownDb from "../../componentes_basicos/DropDownDB.svelte";
  import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
  import Toast from "../../componentes_basicos/Toast.svelte";
  import { createEventDispatcher, onDestroy } from "svelte";
  import InputValidacao from "../../componentes_basicos/InputValidacao.svelte";
  import DropSelecao from "../../componentes_basicos/DropSelecao.svelte";
  import DatePicker from "../../componentes_basicos/DatePicker.svelte";
   
  import {
    permissaoUsuario,
    permissaoPlataforma,
    DadosGenericos,
    DadosPaginaAnterior,
    DadosLogin,
  } from "../../Classes/Stores.js";
    import consolar from "../../Classes/Consolar.js";
  export let itens = [];
  export let api;
  export let query_code_inserir;
  export let nao_conectar = false;
  export let titulo = "Inserir novo usuário";
  export let strong = false;
  export let msgSucesso = Constantes.msg_inserido_sucesso;
  export let tituloBotaoEnviar = "Enviar";
  export let nome_componente = "";
  export let naoConfirma = false;
  export let tabela = "";
  let mensagem = "";
  let parametros = {};
  let carregando = false;
  let carregado = false;
  let retorno = "";
  let response = "";
  let senha;
  let confirmacaoSenha;
  let rotuloErro;
  let retornoDrops = [];
  let cpf = "";
  let cpfValido = false;
  let email;
  let confirmaEmail;
  // Defina o modelo de máscara para o telefone

  function mascaraCPF(event) {
    // Cria MÁSCARA DO CPF
    let value = event.target.value;
    value = value.replace(/\D/g, ""); // Remove qualquer caractere que não seja numérico
    /*
        value = value.slice(0, 11); // Limita a 11 dígitos
        if (value.length > 3) {
            value = value.slice(0, 3) + "." + value.slice(3);
        }
        if (value.length > 7) {
            value = value.slice(0, 7) + "." + value.slice(7);
        }
        if (value.length > 11) {
            value = value.slice(0, 11) + "-" + value.slice(11);
        }*/
    //item.valor = value; // Atualiza o valor do input
    cpfValido = validaCPF(value);
    //console.log("validade ", cpfValido);
  }

  function validaCPF(cpf2) {
    // VALIDA CPF

    //console.log("validadndo cpf");
    if (!cpf2) {
      return;
    }
    cpf2 = cpf2.replace(/[^\d]+/g, "");
    //console.log(cpf2);
    if (cpf2.length !== 11 || /^(\d)\1+$/.test(cpf2)) {
      return false;
    }
    let soma = 0;
    for (let i = 0; i < 9; i++) {
      soma += parseInt(cpf2.charAt(i)) * (10 - i);
    }
    let resto = 11 - (soma % 11);
    if (resto === 10 || resto === 11) {
      resto = 0;
    }
    if (resto !== parseInt(cpf2.charAt(9))) {
      return false;
    }
    soma = 0;
    for (let i = 0; i < 10; i++) {
      soma += parseInt(cpf2.charAt(i)) * (11 - i);
    }
    resto = 11 - (soma % 11);
    if (resto === 10 || resto === 11) {
      resto = 0;
    }
    return resto === parseInt(cpf2.charAt(10));
  }

  const dispatch = createEventDispatcher();
  let conexoes = new Conexoes();
  function RetornaDrops(e) {
    ////console.log(e.detail);
    // //console.log("retorna_drops" + e.detail);
    dispatch("retorna_drops", e.detail);
  }
  function RetornaDropsSimples(e) {
    // //console.log(e.detail);
    // //console.log("retorna_drops_simples" + e.detail);
    dispatch("retorna_drops_simples", e.detail);
  }
  export function getParametrosInseridos() {
    rotuloErro = validarObrigatorios();

    ////console.log("aqui1");
    if (rotuloErro != "-valido-") {
      if (nao_conectar != true) {
        mostrarDialogo(Constantes.msg_campos_obrigatorios + rotuloErro);
      }
      // //console.log("aqui2");
      parametros = "";
      dispatch("parametrosInseridos", {
        parametros: parametros,
        erro: rotuloErro,
        tipo: "obrigatorio",
      });
      parametros = {};
      return;
    }
    rotuloErro = validarFormatos();
    //console.log("retorno do validar formato ", rotuloErro);
    if (rotuloErro != "-valido-") {
      if (nao_conectar != true) {
        mostrarDialogo(Constantes.msg_formato_invalido + rotuloErro);
      }
      parametros = "";
      //console.log("aqui3");
      dispatch("parametrosInseridos", {
        parametros: parametros,
        erro: rotuloErro,
        tipo: "invalido",
      });

      parametros = {};
      return;
    }
    if (!ChecaSenha()) {
      //console.log("retornadno");
      return;
    }
    if (!ChecaEmail()) {
      //console.log("email");
      return;
    }
    itens.forEach((item) => {
      if (
        (item.tipo === Tipo.PASSWORD &&
          item.rotulo.endsWith(" (Confirmação)")) ||
        (item.tipo === Tipo.EMAIL_CONFIRMA &&
          item.rotulo.endsWith(" (Confirmação)"))
      ) {
        return;
      }
      //   //console.log(item.nomeColuna);
      //  //console.log(item.valor);
      //  //console.log(parametros);
      if (item.tipo == Tipo.CPF) {
        try {
          item.valor = item.valor.replace(/\D/g, "");
        } catch {
          item.valor = item.valor;
        }
      }
      parametros[item.nomeColuna] = item.valor;
    });
    parametros["query_code"] = query_code_inserir;
    parametros["tabela"] = tabela;
    consolar.log("parametros enviados", parametros);
    dispatch("parametrosInseridos", {
      parametros: { ...parametros },
      erro: rotuloErro,
      tipo: "outro",
    });

    if (nao_conectar != true) {
      conectar();
    }
  }
  export function limparCampos() {
    itens.forEach((item) => {
      item.valor = ""; // Limpa o valor de cada item
    });
  }
  function ChecaEmail() {
    //console.log("email e confirma " + email.value + " -" + confirmaEmail.value);
    if (email && confirmaEmail && email.value !== confirmaEmail.value) {
      mostrarDialogo(Constantes.msg_emails_nao_coincidem);
      parametros = "";
      dispatch("parametrosInseridos", {
        parametros: parametros,
        erro: rotuloErro,
        tipo: "email",
      });
      parametros = {};
      return false;
    } else {
      return true;
    }
  }
  function ChecaSenha() {
    //console.log(      "senha e confirma " + confirmacaoSenha.value + " -" + senha.value,    );
    if (confirmacaoSenha && senha && confirmacaoSenha.value !== senha.value) {
      mostrarDialogo(Constantes.msg_senhas_nao_coincidem);
      parametros = "";
      dispatch("parametrosInseridos", {
        parametros: parametros,
        erro: rotuloErro,
        tipo: "senha",
      });
      parametros = {};
      return false;
    } else {
      return true;
    }
  }
  function validarObrigatorios() {
    for (let item of itens) {
      if (
        item.obrigatorio &&
        (item.valor == "" ||
          item.valor == null ||
          (typeof item.valor === "string" && item.valor.trim() == ""))
      ) {
        return item.rotulo; // Se o valor for vazio , retorna rotulo
      }
    }

    // //console.log("aqui---");
    return "-valido-";
  }
  function nomeSobrenome(nome) {
    // Divide o nome em partes usando o espaço como delimitador
    const parts = nome.trim().split(" ");

    // Verifica se há pelo menos duas partes (nome e sobrenome)
    return parts.length > 1;
  }

  function validarFormatos() {
    // Validação de formatos
    const regex = {
      [Tipo.NUMERO]: /^\d+$/,
      [Tipo.EMAIL]: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      [Tipo.EMAIL_CONFIRMA]: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      [Tipo.TELEFONE]: /^\d{10,11}$/,
      // Adicione mais tipos de validação conforme necessário
    };

    for (let item of itens) {
      if (item.tipo == Tipo.NOME_SOBRENOME && item.obrigatorio) {
        if (!nomeSobrenome(item.valor)) {
          return "Falta sobrenome";
        }
      } else if (item.tipo == Tipo.CPF) {
        if (!cpfValido) {
          return item.rotulo;
        }
      } else if (
        regex[item.tipo] &&
        item.valor !== undefined && // Verifica se item.valor é undefined
        typeof item.valor === "string" &&
        item.valor.trim() !== "" &&
        !regex[item.tipo].test(item.valor)
      ) {
        return item.rotulo; // Se o formato não corresponder à regex, retorna falso
      }
    }

    return "-valido-"; // Se todas as validações passarem, retorna verdadeiro
  }
  export async function conectar() {
    mensagem = "";
    conexoes = new Conexoes();
    carregando = true;
    carregado = false;
    console.log("COnectando");
    response = await conexoes.conecta(api, parametros);
    mensagem = response;
    //console.log(mensagem);
    if (response && response.sucesso) {
      if (!naoConfirma) {
        mensagem = Constantes.msg_inserido_sucesso;
      }
      DadosGenericos.set(parametros);
      dispatch("finalizado_sucesso");
    } else if (!response.sucesso && response.motivo == "duplicado") {
      mensagem = Constantes.msg_erro_insercao_dupla;
    } else {
      mensagem = Constantes.msg_erro_conexao_bd;
    }

    carregando = false;
    carregado = true; // Esconde o ícone de carregamento quando terminar
  }
  function getInputClass(item) {
    return `form-control${item.tipo === Tipo.TELEFONE ? " tel-input" : ""}`;
  }
  function mostrarDialogo(msg) {
    mensagem = msg;
    ////console.log("aqui4" + mensagem);
  }
  onDestroy(() => {
    getParametrosInseridos();
  });
</script>

<LoadingTela isLoading={carregando} />

<div class="header-bar">
  {#if strong}
    <strong><h3>{titulo}</h3></strong>
  {:else}
    {titulo}
  {/if}
</div>
<div class="card1">
  {#each itens as item}
    <div class="form-group">
      {#if item.tipo != Tipo.DIVISOR && item.tipo != Tipo.HIDDEN}
        <label for={item.nomeColuna}
          >{item.rotulo}{#if item.obrigatorio}<span style="color: red;">*</span
            >{/if}</label
        >
      {/if}
      {#if item.tipo === Tipo.TEXTO}
        <input
          type="text"
          bind:value={item.valor}
          maxlength={item.tamanho}
          placeholder={item.rotulo}
          id={item.nomeColuna}
          class={getInputClass(item)}
        />
      {:else if item.tipo === Tipo.NOME_SOBRENOME}
        <input
          type="text"
          bind:value={item.valor}
          maxlength={item.tamanho}
          placeholder={item.rotulo}
          id={item.nomeColuna}
          class={getInputClass(item)}
        />
      {:else if item.tipo === Tipo.NUMERO}
        <input
          type="number"
          bind:value={item.valor}
          maxlength={item.tamanho}
          placeholder={item.rotulo}
          id={item.nomeColuna}
          step={item.passos}
          max={9999999}
          class={getInputClass(item)}
        />
      {:else if item.tipo === Tipo.DECIMAL}
        <input
          type="number"
          bind:value={item.valor}
          maxlength={item.tamanho}
          placeholder={item.rotulo}
          id={item.nomeColuna}
          step={item.passos}
          max={9999999.9}
          pattern={`\\d+(\\.\\d{1,${item.casas_decimais}})?`}
          class={getInputClass(item)}
        />
      {:else if item.tipo === Tipo.HORA}
        <input
          type="time"
          bind:value={item.valor}
          maxlength={item.tamanho}
          placeholder={item.rotulo}
          id={item.nomeColuna}
          class={getInputClass(item)}
        />
      {:else if item.tipo === Tipo.PASSWORD}
        <input
          type="password"
          bind:value={item.valor}
          maxlength={item.tamanho}
          placeholder={item.rotulo}
          id={item.nomeColuna}
          class={getInputClass(item)}
          bind:this={senha}
        />

        <input
          type="password"
          bind:this={confirmacaoSenha}
          maxlength={item.tamanho}
          placeholder={`${item.rotulo} (Confirmação)`}
          autocomplete="off"
          id={`${item.nomeColuna}-confirmacao`}
          class={getInputClass(item)}
        />
      {:else if item.tipo === Tipo.EMAIL}
        <input
          type="email"
          bind:value={item.valor}
          maxlength={item.tamanho}
          placeholder={item.rotulo}
          id={item.nomeColuna}
          class={getInputClass(item)}
        />
      {:else if item.tipo === Tipo.EMAIL_CONFIRMA}
        <input
          type="email"
          bind:value={item.valor}
          maxlength={item.tamanho}
          placeholder={item.rotulo}
          id={item.nomeColuna}
          class={getInputClass(item)}
          bind:this={email}
        />
        <input
          type="email"
          bind:this={confirmaEmail}
          maxlength={item.tamanho}
          autocomplete="off"
          placeholder={`${item.rotulo} (Confirmação)`}
          id={`${item.nomeColuna}-confirmacao`}
          class={getInputClass(item)}
        />
      {:else if item.tipo === Tipo.CPF}
        <input
          type="text"
          placeholder={item.rotulo + " (apenas números)"}
          bind:value={item.valor}
          id={item.nomeColuna}
          class="form-control {cpfValido === true
            ? 'valid'
            : cpfValido === false
              ? 'invalid'
              : 'invalid'}"
          on:input={(e) => mascaraCPF(e)}
        />
      {:else if item.tipo === Tipo.TEXTO_VALIDADO}
        <InputValidacao
          rotulo={item.rotulo}
          bind:entrada={item.valor}
          id={item.nomeColuna}
          classe={getInputClass(item)}
          parametros={parametrosInputValidacao}
          api={apiInputValidacao}
        />
      {:else if item.tipo === Tipo.TELEFONE}
        <input
          type="number"
          bind:value={item.valor}
          maxlength={item.tamanho}
          placeholder={item.rotulo}
          id={item.nomeColuna}
          class={getInputClass(item)}
        />
      {:else if item.tipo === Tipo.DATA}
        <input
          type="date"
          bind:value={item.valor}
          maxlength={item.tamanho}
          placeholder={item.rotulo}
          id={item.nomeColuna}
          class={getInputClass(item)}
        />
         {:else if item.tipo === Tipo.TIME}
        <input
          type="time"
          bind:value={item.valor}
          maxlength={item.tamanho}
          placeholder={item.rotulo}
          id={item.nomeColuna}
          class={getInputClass(item)}
        />
      {:else if item.tipo === Tipo.DATEPICKER}
        <DatePicker id={item.nomeColuna} bind:saida={item.valor} />
      {:else if item.tipo === Tipo.DROPSELECAO}
        <DropSelecao
          config={item.config_selecao}
          id={item.nomeColuna}
          bind:saida={item.valor}
        />
      {:else if item.tipo === Tipo.TG}
        <Switch
          checked={item.valor}
          on:change={() => (item.valor = !item.valor ? 1 : 0)}
          id={item.nomeColuna}
        />
        
      {:else if item.tipo === Tipo.SELECAO}
        <!-- <DropDownDb config = {item.config_drop_down}  on:retorno = {(e)=>{item.valor=e.detail}}        
        />

        -->

        <DropDownDb
          config={item.config_drop_down}
          on:retorno={(e) => RetornaDrops(e)}
          on:retorno_simples={(e) => RetornaDropsSimples(e)}
          bind:saida={item.valor}
          class="text-field"
        />
      {:else if item.tipo === Tipo.HIDDEN}
        <input
          type="hidden"
          value={item.valor}
          maxlength={item.tamanho}
          placeholder={item.rotulo}
          id={item.nomeColuna}
          class={getInputClass(item)}
        />
      {:else if item.tipo === Tipo.DIVISOR}
        <div class="header-bar">
          {#if item.strong}
            <strong><h3>{item.rotulo}</h3></strong>
          {:else}
            {item.rotulo}
          {/if}
        </div>
      {/if}
    </div>
  {/each}
  <slot></slot>
</div>
{#if nao_conectar != true}
  <button
    class="btn btn-block botao-laranja mb-5"
    on:click={getParametrosInseridos}>{tituloBotaoEnviar}</button
  >{/if}

{#if mensagem != ""}
  {#if response != "" && response.sucesso}
    {#if !naoConfirma}
      <CaixaDeDialogo
        message={msgSucesso}
        on:close={() => {
          {
            dispatch("sucesso", true);
            mensagem = "";
            retorno = "";
          }
        }}
      />{/if}
  {:else}
    <CaixaDeDialogo
      message={mensagem}
      on:close={() => {
        mensagem = "";
        retorno = "";
        conexoes.isLoading = false;
      }}
    />
  {/if}
{/if}

<style>
  .botao-laranja {
    background-color: #f38c23;
    color: white;
  }
  .header-bar {
    background-color: #459bfd;
    padding-left: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    color: #ffffff;
    margin-bottom: 10px;
    margin-top: 15px;
    margin-left: 16px;
    margin-right: 16px;
  }

  .card1 {
    width: 100%;
    padding: 15px;

    margin-bottom: 15px;
  }

  .form-group {
    margin-bottom: 15px;
  }

  .form-control {
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition:
      border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
  }
  .form-control:focus {
    color: var(--bs-body-color);
    background-color: var(--bs-body-bg);
    border-color: #86b7fe;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  }

  .valid {
    background-color: #fff; /* Verde claro */
  }

  .invalid {
    background-color: #f8d7da; /* Vermelho claro */
  }

  .valid:focus {
    background-color: #fff; /* Verde claro quando em foco */
  }

  .invalid:focus {
    background-color: #f8d7da; /* Vermelho claro quando em foco */
  }
  .tel-input {
    /* Estilos adicionais para campos de telefone */
  }

  input {
    margin-bottom: 10px;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
</style>
